import React, { useState } from "react";
import { Button, Form } from "reactstrap";
import MessageInput from "./MessageInput";
import { addChat } from "store/actions/resolutionCenterAction";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const ChatFooter = ({ athleteData }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [newMessage, setNewMessage] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addChat(athleteData?.id, newMessage, id));
    setNewMessage("");
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className="d-flex form-container border rounded mt-3 "
    >
      <div className="d-flex align-items-center w-100 bg-white rounded position-relative">
        <MessageInput
          disabled={false}
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />

        <Button
          className={`bg-primary rounded border-0 message-send-btn py-1 px-2 mt-1`}
          type="submit"
        >
          <i className="fas text-white fa-paper-plane"></i>
        </Button>
      </div>
    </Form>
  );
};

export default ChatFooter;
